// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1NA0Z","header":"PatientQuestionnaire_header__3Bi3k","info":"PatientQuestionnaire_info__2QpqN"};